import React, { Component } from "react";
import {
  PieChart,
  Pie,
  Legend,
  Tooltip,
  Cell,
  ResponsiveContainer
} from "recharts";
import Teams from "api/Teams";
import Styled from "components/pm/style";
import { view } from "@risingstack/react-easy-state";

const DIGITAL_MARKETING_LABEL = "Digital Marketing";
const TRADITIONAL_MARKETING_LABEL = "Traditional Marketing";
const DIRECT_SALES_LABEL = "Direct Sales";
const DISTRIBUTORS_LABEL = "Distributors";

class DonutPMDecisionsCurrentMarketingSpend extends Component {
  get data() {
    return [
      {
        name: TRADITIONAL_MARKETING_LABEL,
        value: this.calculatePercentage(
          this.props.sumOfTraditionalMarketingSpend,
          this.props.sumOfMarketingSpend
        )
      },
      {
        name: DIGITAL_MARKETING_LABEL,
        value: this.calculatePercentage(
          this.props.sumOfDigitalMarketingSpend,
          this.props.sumOfMarketingSpend
        )
      },
      {
        name: DIRECT_SALES_LABEL,
        value: this.calculatePercentage(
          this.props.sumOfDirectSalesSpend,
          this.props.sumOfMarketingSpend
        )
      },
      {
        name: DISTRIBUTORS_LABEL,
        value: this.calculatePercentage(
          this.props.sumOfDistributorsSpend,
          this.props.sumOfMarketingSpend
        )
      }
    ];
  }

  calculatePercentage(value, sum) {
    if (sum === 0) return 0;

    const percentage = (value / sum) * 100;
    return Math.abs(parseFloat(percentage.toFixed(2), 10));
  }

  render() {

    return (
      <Styled.CMS.Chart>
        <ResponsiveContainer width="100%" height={150}>
          <PieChart>
            <Legend
              iconType="circle"
              layout="vertical"
              align="right"
              verticalAlign="top"
            />
            <Tooltip formatter={val => `${val}%`} />
            <Pie
              data={this.data}
              cx={63}
              cy={78}
              innerRadius={27}
              outerRadius={63}
              labelLine={true}
              dataKey="value"
            >
              <Cell fill={Teams.traditionalMarketingColor()} />
              <Cell fill={Teams.digitalMarketingColor()} />
              <Cell fill={Teams.directSalesColor()} />
              <Cell fill={Teams.distributorsColor()} />
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </Styled.CMS.Chart>
    );
  }
}

export default view(DonutPMDecisionsCurrentMarketingSpend);



// WEBPACK FOOTER //
// ./src/components/pm/decisions/charts/DonutPMDecisionsCurrentMarketingSpend.js